import { format, parseISO } from "date-fns"
import React from "react"
import { Row } from "react-bootstrap"

const WeekDays = ({ week }) => (
  <Row className="flex-nowrap mx-0 justify-content-between">
    {week.map(({ date }, idx) => (
      <div className="session-calendar_week-day" key={idx}>
        <span className="session-calendar_week-day-name">{format(new Date(parseISO(date)), "EEEE")}</span>
      </div>
    ))}
  </Row>
)

export default WeekDays
